/* src/app/tag-management/tag-management.component.scss */
.menu {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 0 16px;
}
.menu input[type=text] {
  padding: 7px 12px;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  font-size: 13px;
  min-width: 220px;
  outline: none;
}
.menu input[type=text]:focus {
  border-color: #888;
}
.btn-create {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 14px;
  background: white;
  color: #333;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
}
.btn-create:hover {
  background: #f5f5f5;
}
.btn-create-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.tag-pill {
  display: inline-block;
  padding: 3px 12px;
  border-radius: 14px;
  font-size: 12px;
  font-weight: 500;
  background: #E8F5E9;
  color: black;
}
.mat-mdc-cell {
  text-align: left;
}
.mat-mdc-row:hover {
  background-color: #fafafa;
}
.reports-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 10px;
  border: 1px solid #d0d0d0;
  background: white;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  color: #333;
}
.reports-btn:hover {
  background: #f5f5f5;
}
.reports-btn-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #666;
}
.reports-btn-chevron {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #888;
}
.menu-trigger {
  cursor: pointer;
  color: #888;
  background: transparent;
  border: none;
  display: inline-flex;
  align-items: center;
  padding: 4px;
  border-radius: 4px;
}
.menu-trigger:hover {
  background: #f0f0f0;
  color: #333;
}
[popover].row-popover-menu {
  position: fixed;
  margin: 0;
  padding: 4px 0;
  min-width: 160px;
  background: white;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  inset: unset;
}
.popover-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  font-size: 13px;
  cursor: pointer;
  color: #333;
  text-decoration: none;
}
.popover-item:hover {
  background: #fafafa;
}
.popover-item.danger {
  color: #c0392b;
}
.popover-item-icon {
  font-size: 15px;
  width: 15px;
  height: 15px;
  color: #666;
}
.popover-divider {
  height: 1px;
  background: #f0f0f0;
  margin: 4px 0;
}
.delete-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.delete-modal {
  background: white;
  border-radius: 4px;
  width: 440px;
  padding: 14px 18px 18px;
}
.delete-modal-close {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 8px;
}
.delete-modal-close button {
  background: white;
  border: 1px solid #d0d0d0;
  width: 26px;
  height: 26px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.delete-modal-close button:hover {
  background: #f5f5f5;
}
.delete-modal-title {
  color: #e53935;
  font-size: 24px;
  font-weight: 500;
  padding: 10px 4px 16px;
}
.delete-modal-body {
  font-size: 13px;
  color: #666;
  padding: 0 4px 12px;
}
.delete-modal-input-wrap {
  padding: 4px 4px 0;
}
.delete-modal-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;
}
.delete-modal-input {
  width: 100%;
  border: none;
  border-bottom: 1px solid #888;
  padding: 8px 0;
  font-size: 14px;
  outline: none;
  background: transparent;
}
.delete-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 24px;
}
.btn-cancel {
  background: #888;
  color: white;
  border: none;
  padding: 6px 18px;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
}
.btn-cancel:hover {
  background: #777;
}
.btn-ok {
  background: #e53935;
  color: white;
  border: none;
  padding: 6px 22px;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
}
.btn-ok:disabled {
  background: #bdbdbd;
  cursor: default;
}
.btn-ok:not(:disabled):hover {
  background: #c62828;
}
/*# sourceMappingURL=tag-management.component.css.map */
